import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-sales-group-management',
  styleUrls: ['./sales-group-management.component.scss'],
  templateUrl: './sales-group-management.component.html'
})
export class SalesGroupManagementComponent implements OnInit {
  customerManagers: any;
  inspectors: any;
  isLoading: boolean;
  plants: any;
  requestLoading = false;
  salesGroupInfo: any;
  salesOrganizations: any;
  selectedSendNotification: number;
  values = [
    {
      id: 0,
      name: 'ΟΧΙ',
    }, {
      id: 1,
      name: 'ΝΑΙ',
    }
  ];

  constructor(private commonService: CommonService,
              private toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
  }

  public async ngOnInit(): Promise<any> {
    await this.initializeCustomerManagersInfo();
    await this.initializeInspectorsInfo();
    await this.initializeSalesOrganizationInfo();
    await this.initializePlantsInfo();
    await this.initializeSalesGroupInfo();
    this.isLoading = false;
  }

  async initializeSalesGroupInfo() {
    try {
      this.salesGroupInfo = await this.commonService.getSimpleList(`sales_group?filter=category_id is null&order=id`);
      for (const saleGroup of this.salesGroupInfo) {
        saleGroup.selectedInspector = this.inspectors.find(inspector => inspector.id === saleGroup.inspector_id);
        saleGroup.selectedSaleOrganization = this.salesOrganizations.find(sale => sale.id === saleGroup.sales_organization_id);
        saleGroup.selectedPlant = this.plants.find(plant => +plant.recycle_plant === saleGroup.recycle_plant);
        saleGroup.selectedCustomerManager = this.customerManagers.find(customerManager => customerManager.id === saleGroup.customer_manager_id);
        saleGroup.selectedSendNotification = this.values.find(value => value.id === saleGroup.send_notification);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις πληροφορίες των δρομολογίων');
    }
  }

  async initializeInspectorsInfo() {
    try {
      this.inspectors = await this.commonService.getSimpleList(`user?filter=role_id=4 AND status_value = 1&order=name`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις πληροφορίες των επιθεωρητών');
    }
  }

  async initializeCustomerManagersInfo() {
    try {
      this.customerManagers = await this.commonService.getSimpleList(`user?filter=role_id=17 AND status_value = 1&order=name`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις πληροφορίες των υπεύθυνων πελατών');
    }
  }

  async initializeSalesOrganizationInfo() {
    try {
      this.salesOrganizations = await this.commonService.getSimpleList(`sales_organization`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις πληροφορίες των sales organization');
    }
  }

  async initializePlantsInfo() {
    try {
      this.plants = await this.commonService.getSimpleList(`sales_group/plant`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις πληροφορίες των plants');
    }
  }

  async updateInspector(item1: any) {
    const model = {
      id: item1.id,
      type: 'inspector',
      value_id: item1.selectedInspector.id
    };
    try {
      this.requestLoading = true;
      await this.commonService.updateObject(`sales_group`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε τον επιθεωρητή του δρομολογίου');
    } finally {
      this.requestLoading = false;
    }
  }

  async updateOrganization(item1: any) {
    const model = {
      id: item1.id,
      type: 'organization',
      value_id: item1.selectedSaleOrganization.id
    };
    try {
      this.requestLoading = true;
      await this.commonService.updateObject(`sales_group`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε το Sales Organization του δρομολογίου');
    } finally {
      this.requestLoading = false;
    }
  }

  async updateCustomerManager(item1: any) {
    const model = {
      id: item1.id,
      type: 'customer_manager',
      value_id: item1.selectedCustomerManager.id
    };
    try {
      this.requestLoading = true;
      await this.commonService.updateObject(`sales_group`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε τον Υπεύθυνο Πελατών του δρομολογίου');
    } finally {
      this.requestLoading = false;
    }
  }

  async updateSendNotification(item1: any) {
    const model = {
      id: item1.id,
      type: 'notification',
      value_id: item1.selectedSendNotification.id
    };
    try {
      this.requestLoading = true;
      await this.commonService.updateObject(`sales_group`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε την Αποστολή Ειδοποίησης του δρομολογίου');
    } finally {
      this.requestLoading = false;
    }
  }

  async updatePlant(item1: any) {
    const model = {
      id: item1.id,
      type: 'plant',
      value_id: item1.selectedPlant.recycle_plant
    };
    try {
      this.requestLoading = true;
      await this.commonService.updateObject(`sales_group`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε το Plant του δρομολογίου');
    } finally {
      this.requestLoading = false;
    }
  }
}
